const angularModule = angular.module('com.comtrade.shared.sharedModule.ctxTabs', []);

angularModule.component('ctxTabs', require('./ctxTabs.component'));
angularModule.component('ctxTab', require('./ctxTab.component'));
angularModule.service('tabContentService', require('./ctxTabContent.service'));
angularModule.animation('.ctx-tab-content', require('./ctxTabContent.animation'));

module.exports = angularModule;


// WEBPACK FOOTER //
// ./src/shared/ctxTabs/ctxTabs.module.js